angular
  .module('sms.common.services')
  .service('emailValidationService', emailValidationService)

// Email pattern from email-validator

const EMAIL_REGEX =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

function emailValidationService() {
  const service = {}
  service.pattern = EMAIL_REGEX
  return service
}
